:host {
  display: flex;
  position: relative;
}

.left-icon {
  transform: rotate(0deg);
}

.right-icon {
  transform: rotate(180deg);
}

.down-icon {
  transform: rotate(270deg);
}

.up-icon {
  transform: rotate(90deg);
}

// *** Phosphor Icons ***
@font-face {
  font-family: "Phosphor-Bold";
  src: url("https://unpkg.com/@phosphor-icons/web@2.0.3/src/bold/Phosphor-Bold.woff2") format("woff2"),
    url("https://unpkg.com/@phosphor-icons/web@2.0.3/src/bold/Phosphor-Bold.woff") format("woff"),
    url("https://unpkg.com/@phosphor-icons/web@2.0.3/src/bold/Phosphor-Bold.ttf") format("truetype"),
    url("https://unpkg.com/@phosphor-icons/web@2.0.3/src/bold/Phosphor-Bold.svg#Phosphor-Bold") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.ph-bold {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Phosphor-Bold" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ph-bold.ph-caret-circle-double-down:before {
  content: "\e9f1";
}
.ph-bold.ph-caret-circle-double-left:before {
  content: "\e9f2";
}
.ph-bold.ph-caret-circle-double-right:before {
  content: "\e9f3";
}
.ph-bold.ph-caret-circle-double-up:before {
  content: "\e9f4";
}
.ph-bold.ph-caret-circle-down:before {
  content: "\e9f5";
}
.ph-bold.ph-caret-circle-left:before {
  content: "\e9f6";
}
.ph-bold.ph-caret-circle-right:before {
  content: "\e9f7";
}
.ph-bold.ph-caret-circle-up:before {
  content: "\e9f8";
}
.ph-bold.ph-caret-circle-up-down:before {
  content: "\e9f9";
}
.ph-bold.ph-caret-double-down:before {
  content: "\e9fa";
}
.ph-bold.ph-caret-double-left:before {
  content: "\e9fb";
}
.ph-bold.ph-caret-double-right:before {
  content: "\e9fc";
}
.ph-bold.ph-caret-double-up:before {
  content: "\e9fd";
}
.ph-bold.ph-caret-down:before {
  content: "\e9fe";
}
.ph-bold.ph-caret-left:before {
  content: "\e9ff";
}
.ph-bold.ph-caret-right:before {
  content: "\ea00";
}
.ph-bold.ph-caret-up:before {
  content: "\ea01";
}
.ph-bold.ph-caret-up-down:before {
  content: "\ea02";
}
.ph-bold.ph-horse:before {
  content: "\eb93";
}
.ph-bold.ph-check-circle:before {
  content: "\ea31";
}
.ph-bold.ph-prohibit:before {
  content: "\ec94";
}
.ph-bold.ph-prohibit-inset:before {
  content: "\ec95";
}
.ph-bold.ph-x:before {
  content: "\eddb";
}
.ph-bold.ph-x-circle:before {
  content: "\eddc";
}
.ph-bold.ph-x-square:before {
  content: "\eddd";
}
.ph-bold.ph-magnifying-glass:before {
  content: "\ebdd";
}
.ph-bold.ph-magnifying-glass-minus:before {
  content: "\ebde";
}
.ph-bold.ph-magnifying-glass-plus:before {
  content: "\ebdf";
}
.ph-bold.ph-ticket:before {
  content: "\ed73";
}
.ph-bold.ph-shopping-cart:before {
  content: "\ecde";
}
.ph-bold.ph-shopping-cart-simple:before {
  content: "\ecdf";
}
.ph-bold.ph-question:before {
  content: "\ec9f";
}
.ph-bold.ph-credit-card:before {
  content: "\ea73";
}
.ph-bold.ph-pencil:before {
  content: "\ec56";
}
.ph-bold.ph-pencil-circle:before {
  content: "\ec57";
}
.ph-bold.ph-pencil-line:before {
  content: "\ec58";
}
.ph-bold.ph-pencil-simple:before {
  content: "\ec59";
}
.ph-bold.ph-pencil-simple-line:before {
  content: "\ec5a";
}
.ph-bold.ph-pencil-simple-slash:before {
  content: "\ec5b";
}
.ph-bold.ph-pencil-slash:before {
  content: "\ec5c";
}
.ph-bold.ph-map-pin:before {
  content: "\ebe0";
}
.ph-bold.ph-map-pin-line:before {
  content: "\ebe1";
}
.ph-bold.ph-warning:before {
  content: "\edbf";
}
.ph-bold.ph-warning-circle:before {
  content: "\edc0";
}
.ph-bold.ph-warning-diamond:before {
  content: "\edc1";
}
.ph-bold.ph-warning-octagon:before {
  content: "\edc2";
}
// **********************